
// Libraries
import { defineComponent } from 'vue';

// Components
import DuoView from 'client/containers/user/Views/DuoView.vue';

// Services
import duoConfigService from 'client/services/duoConfigService';
import userLoginService from 'client/services/userLoginService';

// Constants
import { useMfaLabels } from 'client/util/Constants/MfaLabels';

export default defineComponent({
  name: 'DuoUserLoginHandler',

  components: {
    DuoView,
  },

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
  },

  setup() {
    const uiLabel = useMfaLabels();
    return { uiLabel };
  },

  data() {
    return {
      isLoading: true,
      showFrame: false,
      token: '',
    };
  },

  mounted() {
    this.handleDuoSetup();
  },

  methods: {
    async handleDuoSetup(): Promise<void> {
      try {
        const token = await duoConfigService.setUpDuoForLogin(this.verifyDuo);

        this.showFrame = true;
        this.token = token;
      } catch (error: any) {
        this.$emit('error', error);
      } finally {
        this.isLoading = false;
      }
    },

    // eslint-disable-next-line no-undef
    async verifyDuo(form: DuoForm): Promise<void> {
      try {
        await userLoginService.submitDuo(form, this.token);
        this.$emit('success');
      } catch (error) {
        this.$emit('error', error);
      }
    },
  },
});
